export class IntervalMaxEmissionsReached extends Error {
  constructor() {
    super('Maximum number of emissions reached.')
    Object.setPrototypeOf(this, IntervalMaxEmissionsReached.prototype)
  }
}
